import React, { useState } from 'react';
import { Input } from '../ui/input';
import { Search } from 'lucide-react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const nombreCliente = (c) =>
  (c.tipo_cliente === 'empresa' ? c.empresa || c.nombre_contacto : c.nombre_contacto || c.empresa) || '';

// Buscador de fichas del CRM (GET /comercial/buscar). Con un cliente elegido muestra
// sólo ese cliente y un botón para cambiarlo.
export function BuscadorCliente({ seleccionado, onSeleccionar, onQuitar, autoFocus = false }) {
  const [query, setQuery] = useState('');
  const [resultados, setResultados] = useState([]);

  const buscar = async (q) => {
    setQuery(q);
    if (q.length < 2) { setResultados([]); return; }
    try {
      const r = await axios.get(`${API_URL}/api/comercial/buscar`, { params: { q }, withCredentials: true });
      setResultados(r.data.results || []);
    } catch {
      setResultados([]);
    }
  };

  if (seleccionado) {
    return (
      <div className="flex items-center justify-between p-3 rounded-lg bg-emerald-500/10 border border-emerald-500/30" data-testid="buscar-cliente-seleccionado">
        <span className="text-sm text-emerald-300">
          {nombreCliente(seleccionado)} · <span className="font-mono text-xs">{seleccionado.client_code}</span>
        </span>
        {onQuitar && (
          <button type="button" onClick={onQuitar} className="text-xs text-zinc-400 hover:text-white">Cambiar</button>
        )}
      </div>
    );
  }

  return (
    <>
      <div className="relative">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-zinc-500" />
        <Input
          value={query}
          onChange={(e) => buscar(e.target.value)}
          placeholder="Buscar cliente por nombre, código, teléfono..."
          autoFocus={autoFocus}
          className="pl-9 bg-white/[0.03] border-white/10 text-white placeholder:text-zinc-600"
          data-testid="buscar-cliente-input"
        />
      </div>
      {resultados.length > 0 && (
        <div className="mt-2 rounded-lg border border-white/10 divide-y divide-white/[0.06] max-h-48 overflow-y-auto">
          {resultados.map((c) => (
            <button
              key={c.id}
              type="button"
              onClick={() => { setQuery(''); setResultados([]); onSeleccionar(c); }}
              className="w-full p-2.5 text-left text-sm text-zinc-300 hover:bg-white/[0.05]"
              data-testid={`buscar-cliente-resultado-${c.id}`}
            >
              {nombreCliente(c)} <span className="text-xs text-zinc-500 font-mono">{c.client_code}</span>
              {c.telefono && <span className="text-xs text-zinc-600"> · {c.telefono}</span>}
            </button>
          ))}
        </div>
      )}
    </>
  );
}
